// extracted by mini-css-extract-plugin
export default {"title":"articleTitle_title__QR2KL"};